import { render, staticRenderFns } from "./Banner8.vue?vue&type=template&id=dd84c002"
import script from "./Banner8.vue?vue&type=script&lang=js"
export * from "./Banner8.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports